<template>
  <div :class="jel_getClassObject(content)" class="menuBas px-md-2">
    <Menu :content="content" class="text-center">
      <template #element="{ itemElement }">
        <div class="item" :class="{ 'menu-titre': itemElement.image }">
          <b-img-lazy
            v-if="itemElement.image"
            :src="jel_getFichierSrc(itemElement.image)"
            :alt="itemElement.item"
          />
          <div :class="{ 'padding-menu-bas': !itemElement.image }">
            {{ itemElement.item }}
          </div>
        </div>
      </template>
    </Menu>
  </div>
</template>

<script>
import Menu from '@/components/base/Menu';

export default {
  name: 'MenuBas',
  // eslint-disable-next-line vue/no-reserved-component-names
  components: { Menu },
  props: { content: { type: Object, required: true } },
};
</script>

<style lang="scss" scoped>
div.menuBas {
  background: #f2f7fc;
  border-top: 1px solid rgba(21, 38, 101, 0.1);
}
div::v-deep div.list-group {
  flex-direction: row;
  justify-content: space-between;
  .list-group-item {
    padding: 0.25rem 0;
    background: inherit;
    width: stretch;
    border-top: 2px solid rgba(0, 0, 0, 0);
    top: -1px;
    &.router-link-exact-active {
      border-top: 2px solid #0056ac;
      border-radius: 0;
      .item svg {
        color: $couleur-primaire-bouton-theme-clair;
      }
    }
    .item {
      margin: 0 auto;
      svg {
        font-size: 1.5rem;
        color: #828db5;
      }
      > div {
        font-size: 0.575rem;
        color: $couleur-primaire;
        font-family: graphik_regular;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .padding-menu-bas {
    padding-top: 21px;
  }
}
</style>
